import { render, staticRenderFns } from "./StudioProductCheckoutStripeConfirm.vue?vue&type=template&id=1558117d&scoped=true&"
import script from "./StudioProductCheckoutStripeConfirm.vue?vue&type=script&lang=js&"
export * from "./StudioProductCheckoutStripeConfirm.vue?vue&type=script&lang=js&"
import style0 from "./StudioProductCheckoutStripeConfirm.vue?vue&type=style&index=0&id=1558117d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1558117d",
  null
  
)

export default component.exports